
import { ObtieneContrato, eCert_firma, ObtenerFirma, ObtieneTieneFirmaContrato, EnviarToken, ObtieneExcepcion, ObtieneExcepcionPrograma, ObtieneContratoManual, BajarContratoManual, InsertaContratoManual, QuitarContratoManual, BajarContrato, EstadoFirmaEcert, ObtieneContratoWeb } from "../../../application/interactors/Contrato";

export const ObtieneContratoLogic = (selListaContrato: any,
    headers: any,
    codigoNegocio: number,
    codigoPrograma: string,
    rut: number, download: boolean, agnoPromocion: number, codigoPlanificacionAcademica: number, incluirFirmaUDD: boolean, idPeriodo: number, idPersona: number) => {
    return ObtieneContrato(selListaContrato,
        headers,
        codigoNegocio,
        codigoPrograma,
        rut, download,
        agnoPromocion, codigoPlanificacionAcademica, incluirFirmaUDD, idPeriodo, idPersona);
}

// export const ObtieneContratoLogicPDF = (selListaContrato: any,
//     codigoNegocio: number,
//     codigoPrograma: string,
//     rut: number, download: boolean) => {
//     return ObtieneContratoPDF(selListaContrato,
//         codigoNegocio,
//         codigoPrograma,
//         rut, download);
// }

export const EstadoFirmaEcertLogic = (selListaEstado: any,
    rut: number,
    codigoPrograma: string,
    estado: boolean) => {
    return EstadoFirmaEcert(selListaEstado,
        rut,
        codigoPrograma,
        estado);
}

export const eCert_firmaLogic = (selListaContrato: any,
    idProceso: number,
    rut: number,
    anoPromocion: number,
    periodoPromocion: number,
    numeroAlumno: string,
    tipoPersona: number,
    idPeriodo: number) => {
    return eCert_firma(selListaContrato,
        idProceso,
        rut,
        anoPromocion,
        periodoPromocion,
        numeroAlumno,
        tipoPersona,
        idPeriodo
    );
}
export const ObtieneFirmaLogic = (selObtenerFirma: any,
    codigoNegocio: number, idProceso: number, idPeriodo: number, esMenorEdad: boolean = false, idRefirma: number = 0) => {
    return ObtenerFirma(selObtenerFirma, codigoNegocio, idProceso, idPeriodo, esMenorEdad, idRefirma);
}
export const EnviarTokenLogic = (selObtenerFirma: any,
    token: string, codigo: string) => {
    return EnviarToken(selObtenerFirma, token, codigo);
}
export const ObtieneExcepcionLogic = (selListaExcepcion: any,
    rut: number,
    codigoExcepcion: number,
    codigoNegocio: number,
    anio: number,
    periodo: number,
    codigoPrograma: string) => {
    return ObtieneExcepcion(selListaExcepcion,
        rut,
        codigoExcepcion,
        codigoNegocio,
        anio,
        periodo,
        codigoPrograma);
}
export const ObtieneExcepcionProgramaLogic = (selListaExcepcionPrograma: any,
    codigoExcepcion: number,
    codigoNegocio: number,
    codigoCarrera: string,
    anio: number,
    periodo: number,
    codigoPlanificacion: number) => {
    return ObtieneExcepcionPrograma(selListaExcepcionPrograma,
        codigoExcepcion,
        codigoNegocio,
        codigoCarrera,
        anio,
        periodo,
        codigoPlanificacion);
}

export const ObtieneContratoManualLogic = (selListaContratoManual: any,
    rut: number,
    idProceso: number) => {
    return ObtieneContratoManual(selListaContratoManual,
        rut,
        idProceso);
}
export const ObtieneContratoWebLogic = (selListaContratoManual: any,
    rut: number,
    codCarrera: string) => {
    return ObtieneContratoWeb(selListaContratoManual,
        rut,
        codCarrera);
}
export const InsertaContratoManualLogic = (selListaContratoManual: any,
    rut: number,
    idProceso: number,
    anoPromocion: number,
    periodoPromocion: number,
    numeroAlumno: string,
    base64: string,
    idPeriodo: number) => {
    return InsertaContratoManual(selListaContratoManual,
        rut,
        idProceso, anoPromocion, periodoPromocion, numeroAlumno, base64, idPeriodo);
}
export const QuitarContratoManualLogic = (selListaContratoManual: any,
    rut: number,
    idProceso: number) => {
    return QuitarContratoManual(selListaContratoManual,
        rut,
        idProceso);
}
export const BajarContratoManualLogic = (selListaContratoManual: any,
    rut: number,
    idProceso: number) => {
    return BajarContratoManual(selListaContratoManual,
        rut,
        idProceso);
}
export const BajarContratoLogic = (selListaContrato: any,
    rut: number,
    codCarrera: string) => {
    return BajarContrato(selListaContrato,
        rut,
        codCarrera);
}
// export const ObtenerFirmaContratoLogic = (selListaFirmaContrato: any,
//     rut: number,
//     codCarrera: string,
//     codigoPlanificacion: number) => {
//     return ObtenerFirmaContrato(selListaFirmaContrato,
//         rut,
//         codCarrera,
//         codigoPlanificacion);
// }

export const ObtieneTieneFirmaContratoLogic = (selListaTieneFirmaContrato: any,
    codigoNegocio: number,
    rut: number,
    codigoPrograma: string,
    anioPromocion: number,
    periodoPromocion: number,
    codigoPlanificacion: number) => {
    return ObtieneTieneFirmaContrato(selListaTieneFirmaContrato,
        codigoNegocio, rut, codigoPrograma, anioPromocion, periodoPromocion, codigoPlanificacion);
}